import { render, staticRenderFns } from "./ViewAttachmentTable.vue?vue&type=template&id=4df7b71a&"
import script from "./ViewAttachmentTable.vue?vue&type=script&lang=js&"
export * from "./ViewAttachmentTable.vue?vue&type=script&lang=js&"
import style0 from "./ViewAttachmentTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports